import { EMPTY_VALUE } from '../../utils/common'

export const TITLE_TABLE_DOWNLOAD = [
  {
    label: 'library.main.DOWNLOADED_FILES',
    key: 'fileName',
  },
  {
    label: 'library.downloadedFiles.FILE_FORMAT',
    key: 'fileType',
  },
  {
    label: 'library.downloadedFiles.CATEGORY',
    key: 'fileCategoryName',
  },
  {
    label: 'library.downloadedFiles.DELIVERY_DATE',
    key: 'deliveryDate',
  },
  {
    label: 'library.downloadedFiles.EXPIRY_DATE',
    key: 'expiryDate',
  },
  {
    label: ' ',
    key: 'downloadedFileId',
  },
]

export const FIELD_SORT = {
  DELIVERY_DATE: 'DeliveryDate',
  EXPIRY_DATE: 'ExpiryDate',
}

export const ICON_FILE = {
  1: {
    label: '7z',
    className: 'icon-description',
    color: '#cccc',
  },
  2: {
    label: 'ashx',
    className: 'icon-description',
    color: '#cccc',
  },
  3: {
    label: 'crdownload',
    className: 'icon-description',
    color: '#cccc',
  },
  4: {
    label: 'doc',
    className: 'icon-description',
    color: '#cccc',
  },
  5: {
    label: 'docx',
    className: 'icon-description',
    color: '#cccc',
  },
  6: {
    label: 'jpg',
    className: 'icon-description',
    color: '#cccc',
  },
  7: {
    label: 'part',
    className: 'icon-description',
    color: '#cccc',
  },
  8: {
    label: 'pdf',
    className: 'icon-pdf',
    color: '#E0505B',
  },
  9: {
    label: 'png',
    className: 'icon-description',
    color: '#cccc',
  },
  10: {
    label: 'rar',
    className: 'icon-description',
    color: '#cccc',
  },
  11: {
    label: 'rtf',
    className: 'icon-description',
    color: '#cccc',
  },
  12: {
    label: 'swf',
    className: 'icon-description',
    color: '#cccc',
  },
  13: {
    label: 'xls',
    className: 'icon-description',
    color: '#cccc',
  },
  14: {
    label: 'xlsx',
    className: 'icon-excel',
    color: '#3DA967',
  },
  15: {
    label: 'zip',
    className: 'icon-description',
    color: '#cccc',
  },
}

export const ICON_FILE_DEFAULT = {
  label: EMPTY_VALUE,
  className: 'icon-description',
  color: '#cccc',
}

export const NAME_REPORTS = {
  SCREENING: 'SCREENING',
  FIINGATE: 'FIINGATE',
  CREDIT: 'CREDIT',
  STANDARD: 'STANDARD',
  COMPREHENSIVE: 'COMPREHENSIVE',
  INTERNATIONAL: 'INTERNATIONAL',
  BUSINESS: 'BUSINESS',
  DYNAMIC: 'DYNAMIC',
}

export const ID_REPORTS = {
  [NAME_REPORTS.SCREENING]: 1,
  [NAME_REPORTS.FIINGATE]: 2,
  [NAME_REPORTS.CREDIT]: 3,
  [NAME_REPORTS.STANDARD]: 4,
  [NAME_REPORTS.COMPREHENSIVE]: 5,
  [NAME_REPORTS.INTERNATIONAL]: 6,
  [NAME_REPORTS.BUSINESS]: 7,
  [NAME_REPORTS.DYNAMIC]: 8,
}
